import script from "./comparePage.vue?vue&type=script&setup=true&lang=js"
export * from "./comparePage.vue?vue&type=script&setup=true&lang=js"

import "./comparePage.vue?vue&type=style&index=0&id=8f82028c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f82028c"]])

export default __exports__